import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Tracking, TrackingEvent} from '@common/tracking'
import {InputNew} from '@components/common/base/input-new'
import {TabsBase} from '@components/common/base/tabs'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {
  Filter,
  FilterId
} from '@components/extensions-gallery/extensions-gallery'

type TwSidebarProps = {
  $isDisabled?: boolean
}

const TwSidebarSearch = tw.div<TwSidebarProps>`
  ${p => (p.$isDisabled ? 'opacity-20 pointer-events-none' : '')}
`

type TwSidebarFilters = {
  $isDisabled?: boolean
}

const TwSidebarFilters = tw.div<TwSidebarFilters>`
  flex
  flex-col
  gap-2
  mt-20

  ${p => (p.$isDisabled ? 'opacity-20 pointer-events-none' : '')}
`

type ExtensionsListSidebarProps = {
  onResetSearch: () => void
  onSearchChanged: (text: string) => void
  onFilterChanged: (id: FilterId) => void
  isSearchActive: boolean
  isSidebarDisabled: boolean
  searchQuery: string
  filters: Filter[]
  activeFilter: Filter
}

export const ExtensionsListSidebar = observer(
  (props: ExtensionsListSidebarProps) => {
    const {
      isSearchActive,
      isSidebarDisabled,
      onResetSearch,
      onSearchChanged,
      onFilterChanged,
      filters,
      activeFilter,
      searchQuery
    } = props

    return (
      <WithPerfectScrollbar className="h-full p-12">
        <TwSidebarSearch $isDisabled={isSidebarDisabled}>
          <InputNew
            icon="IconSearch"
            type="text"
            value={searchQuery}
            iconRight={searchQuery ? 'IconX' : undefined}
            onIconRightClick={onResetSearch}
            onChange={onSearchChanged}
            onFocus={() => {
              Tracking.send(TrackingEvent.extensionsFocusOnSearch)
            }}
            placeholder={Lang.msg.extensions.gallery.searchPlaceholder}
          />
        </TwSidebarSearch>
        <TwSidebarFilters $isDisabled={isSearchActive || isSidebarDisabled}>
          <TabsBase
            type="default"
            tabs={filters}
            activeId={activeFilter.id}
            onTabClick={id => {
              onFilterChanged(id as FilterId)
              Tracking.send(TrackingEvent.extensionsClickOnFilter, {id})
            }}
            direction="col"
            lineClamp={2}
          />
        </TwSidebarFilters>
      </WithPerfectScrollbar>
    )
  }
)
